import React from "react";
import "./Sidebar.css";

const SOURCE_LABELS = {
  "landing-interior": "Interior Landing",
  "landing-exterior": "Exterior Landing",
};

function sourceLabel(source) {
  if (!source) return "Landing Page";
  return SOURCE_LABELS[source] || source;
}

function Sidebar({ messages, onSelect, selectedMessage }) {
  const selectedId = selectedMessage ? selectedMessage.id : null;

  return (
    <aside className="sidebar">
      {messages.length === 0 && (
        <p className="sidebar-empty">No messages.</p>
      )}
      {messages.map(msg => {
        const isLead = msg.leadType === "lead";
        return (
          <div
            key={msg.id}
            className={`sidebar-item ${msg.id === selectedId ? "active" : ""} ${msg.spam ? "sidebar-item--spam" : ""} ${msg.completed && !msg.spam ? "sidebar-item--completed" : ""} ${isLead && !msg.spam ? "sidebar-item--lead" : ""}`}
            onClick={() => onSelect(msg)}
          >
            <div className="sidebar-content">
              <div className="sidebar-text">
                <div className="sidebar-subject-row">
                  <p className="subject">{msg.subject}</p>
                  {isLead && !msg.spam && <span className="badge badge--lead">LEAD</span>}
                  {msg.spam && <span className="badge badge--spam">SPAM</span>}
                  {msg.completed && !msg.spam && <span className="badge badge--done">✓</span>}
                </div>
                <p className="from">{msg.from}</p>
                {isLead && !msg.spam && (
                  <p className="lead-source-label">{sourceLabel(msg.source)}</p>
                )}
                <p className="snippet">{msg.body}</p>
                {msg.spam && msg.spam_reason && (
                  <p className="spam-reason-label">{msg.spam_reason}</p>
                )}
              </div>
              {msg.images?.length > 0 && !msg.spam && (
                <img
                  src={`/${msg.images[0]}`}
                  alt="thumbnail"
                  className="sidebar-thumb"
                />
              )}
            </div>
          </div>
        );
      })}
    </aside>
  );
}

export default Sidebar;
